import { Box, Container, Typography, Grid, Card, CardContent, Button } from "@mui/material"
import { Rocket, People, EmojiEvents, Store } from "@mui/icons-material"

const pillars = [
  {
    icon: <Rocket sx={{ fontSize: "2.5rem", color: "#2A79E2" }} />,
    brand: "EduCatalyst",
    title: "Master New Skills",
    description: "Join expert-led, practical workshops on AI and tech to stay ahead of the curve.",
    buttonText: "Browse Workshops",
    available: true,
    buttonLink: `https://${process.env.API_HOST}/educatalyst`
  },
  {
    icon: <People sx={{ fontSize: "2.5rem", color: "#F28C28" }} />,
    brand: "EduCommunity",
    title: "Collaborate with Peers",
    description: "Tap into a vibrant support system to ask questions, share ideas, and build relationships.",
    buttonText: "Join the Conversation",
    available: true,
    buttonLink: `https://${process.env.API_HOST}/activity-feed`
  },
  {
    icon: <EmojiEvents sx={{ fontSize: "2.5rem", color: "#003366" }} />,
    brand: "ThoughtCoCreate",
    title: "Showcase Your Vision",
    description: "Have a big idea? We provide the platform to develop and showcase it on a global stage.",
    buttonText: "Explore the Challenge",
    available: true,
    buttonLink: `https://${process.env.API_HOST}/thoughtcocreate`
  },
  {
    icon: <Store sx={{ fontSize: "2.5rem", color: "#28A745" }} />,
    brand: "EduMarketplace",
    title: "Save Valuable Time",
    description: "A library of high-quality, peer-created lesson plans and toolkits.",
    buttonText: "Get Notified on Launch",
    available: false,
  },
]

interface EcosystemSectionProps {
  platformRef: any;
}

export default function EcosystemSection({ platformRef }: EcosystemSectionProps) {
  return (
    <Box id="ecosystem" sx={{ py: 12 }} ref={platformRef}>
      <Container maxWidth="xl">
        <Typography variant="h2" sx={{ textAlign: "center", mb: 6 }}>
          One EcoSystem. Endless Opportunities.
        </Typography>

        <Grid container spacing={4}>
          {pillars.map((pillar, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Card
                sx={{
                  height: "100%",
                  textAlign: "center",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  opacity: pillar.available ? 1 : 0.7,
                  backgroundColor: pillar.available ? "white" : "#fafafa",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <CardContent sx={{ p: 4, display: "flex", flexDirection: "column", height: "100%" }}>
                  <Box sx={{ mb: 2 }}>{pillar.icon}</Box>

                  <Typography
                    variant="overline"
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      color: "#555",
                      letterSpacing: 1,
                      mb: 1,
                    }}
                  >
                    {pillar.brand}
                  </Typography>

                  <Typography variant="h3" sx={{ mb: 2, fontSize: "1.5rem" }}>
                    {pillar.title}
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 3, flexGrow: 1 }}>
                    {!pillar.available && <strong>(Coming Soon) </strong>}
                    {pillar.description}
                  </Typography>

                  <Button
                    variant="outlined"
                    color="primary"
                    href={pillar.buttonLink}
                    disabled={!pillar.available}
                    sx={{
                      backgroundColor: pillar.available ? "white" : "#ccc",
                      borderColor: pillar.available ? "#e0e0e0" : "#ccc",
                      color: pillar.available ? "primary.light" : "white",
                      "&:hover": {
                        borderColor: pillar.available ? "primary.light" : "#bbb",
                        backgroundColor: pillar.available ? "white" : "#bbb",
                        transform: pillar.available ? "translateY(-3px)" : "none",
                      },
                    }}
                  >
                    {pillar.buttonText}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}
